import * as teachingPortfolioData from '../../teachingPortfolioData';
import { ClassImages } from './image-modal'

export const TwoDDesign = () => {
  return (
    ClassImages(teachingPortfolioData.twoDDesign)
  )
}

export const ThreeDDesign = () => {
  return (
    ClassImages(teachingPortfolioData.threeDDesign)
  )
}

export const BeginningMetals = () => {
  return (
    ClassImages(teachingPortfolioData.beginningMetals)
  )
}

export const AdvancedMetals = () => {
  return (
    ClassImages(teachingPortfolioData.advancedMetals)
  )
}
